import React from 'react';
import { useLocation } from 'react-router-dom';
import Signin from './SignIn';
import { Route, Routes } from 'react-router-dom';
import { AuthContextProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoutes';


import HomePage from './HomePage';
import WaitlistHomePage from './WaitlistHome';
import MainHeader from './MainHeader';
import AddNewStudentForm from './AddNewStudentForm';
import PersonDetail from './PersonDetail';
import AbsenceTracker from '../src/AbsenceTracker/AbsenceTracker';
import AddStaff from './AbsenceTracker/AddStaff';
import Staff from './AbsenceTracker/Staff';
import AddAbsence from './AbsenceTracker/AddAbsence';




import './index.css';


// Main Waitlist
import Waitlist from './Waitlist';


// Class Waitlists
import CubsWaitlist from './ClassWaitlists/CubsWaitlist';
import KindergartenWaitlist from './ClassWaitlists/KindergartenWaitlist';
import PandasWaitlist from './ClassWaitlists/PandasWaitlist';
import TeddiesWaitlist from './ClassWaitlists/TeddiesWaitlist';
import KoalasWaitlist from './ClassWaitlists/KoalasWaitlist';
import PreschoolWaitlist from './ClassWaitlists/PreschoolWaitlist';
import PreKWaitlist from './ClassWaitlists/PreKWaitlist';


// Status Waitlists
import ArchivedWaitlist from './StatusWaitlists/ArchivedWaitlist';
import DeclinedWaitlist from './StatusWaitlists/DeclinedWaitlist';
import EnrolledWaitlist from './StatusWaitlists/EnrolledWaitlist';
import StartingWaitlist from './StatusWaitlists/StartingWaitlist';
import PhasedOutWaitlist from './StatusWaitlists/PhasedOutWaitlist';
import FutureIncomingWaitlist from './StatusWaitlists/FutureIncomingWaitlist';



// Health Entries
import CreateEntry from './HealthTrends/CreateEntry'
import HealthEntries from './HealthTrends/EntriesByClass';
import HealthAnalytics from './HealthTrends/HealthAnalytics';
import StaffEntries from './HealthTrends/StaffEntries'
import StudentEntries from './HealthTrends/StudentEntries'



// Student Withdrawals
import CreateNewWithdrawal from './StudentWithdrawals/CreateWithdrawal';
import CreateNewStudent from './StudentWithdrawals/CreateNewStudent';
import StudentWithdrawals from './StudentWithdrawals/StudentWithdrawals';
import NewStudents from './StudentWithdrawals/NewStudents';
import Analytics from './StudentWithdrawals/Analytics';


// Page Not Found
import PageNotFound from './PageNotFound';


function App() {
 const location = useLocation();

 const protectedRoutePrefixes = [
   '/home',
   '/waitlist-home',
   '/add-new-student',
   '/waitlist',
   '/personDetail',
   '/cubswaitlist',
   '/teddieswaitlist',
   '/koalaswaitlist',
   '/pandaswaitlist',
   '/preschoolwaitlist',
   '/prekwaitlist',
   '/kindergartenwaitlist',
   '/archivedwaitlist',
   '/declinedwaitlist',
   '/enrolledwaitlist',
   '/startingwaitlist',
   '/futureincomingwaitlist',
   '/phasedoutwaitlist',
   '/absence-tracker',
   '/absences',
   '/staff',
   '/new-absence',
   '/new-staff',
   '/create-entry',
   '/entries-by-class',
   '/health-analytics',
   '/staff-entries',
   '/student-entries',
   '/create-new-withdrawal',
   '/create-new-student',
   '/student-withdrawals',
   '/new-students',
   '/withdrawal-analytics'
 ];

 const showMainHeader = protectedRoutePrefixes.some(
   (prefix) => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`)
 );


 return (
   <AuthContextProvider>
     {showMainHeader && <MainHeader />}
     <div>
       <Routes>
         <Route path="/" element={<Signin />} />
         <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
         <Route path="/waitlist-home" element={<ProtectedRoute><WaitlistHomePage /></ProtectedRoute>} />
         <Route path="/waitlist" element={<ProtectedRoute><Waitlist /></ProtectedRoute>} />
         <Route path="/add-new-student" element={<ProtectedRoute><AddNewStudentForm /></ProtectedRoute>} />
         <Route path="/personDetail/:id" element={<ProtectedRoute><PersonDetail /></ProtectedRoute>} />
         <Route path="/cubswaitlist" element={<ProtectedRoute><CubsWaitlist /></ProtectedRoute>} />
         <Route path="/teddieswaitlist" element={<ProtectedRoute><TeddiesWaitlist /></ProtectedRoute>} />
         <Route path="/koalaswaitlist" element={<ProtectedRoute><KoalasWaitlist /></ProtectedRoute>} />
         <Route path="/pandaswaitlist" element={<ProtectedRoute><PandasWaitlist /></ProtectedRoute>} />
         <Route path="/preschoolwaitlist" element={<ProtectedRoute><PreschoolWaitlist /></ProtectedRoute>} />
         <Route path="/prekwaitlist" element={<ProtectedRoute><PreKWaitlist /></ProtectedRoute>} />
         <Route path="/kindergartenwaitlist" element={<ProtectedRoute><KindergartenWaitlist /></ProtectedRoute>} />
         <Route path="/archivedwaitlist" element={<ProtectedRoute><ArchivedWaitlist /></ProtectedRoute>} />
         <Route path="/declinedwaitlist" element={<ProtectedRoute><DeclinedWaitlist /></ProtectedRoute>} />
         <Route path="/enrolledwaitlist" element={<ProtectedRoute><EnrolledWaitlist /></ProtectedRoute>} />
         <Route path="/startingwaitlist" element={<ProtectedRoute><StartingWaitlist /></ProtectedRoute>} />
         <Route path="/futureincomingwaitlist" element={<ProtectedRoute><FutureIncomingWaitlist /></ProtectedRoute>} />
         <Route path="/phasedoutwaitlist" element={<ProtectedRoute><PhasedOutWaitlist /></ProtectedRoute>} />
         <Route path="/absence-tracker/*" element={<ProtectedRoute><AbsenceTracker /></ProtectedRoute>} />
         <Route path="/new-staff/*" element={<ProtectedRoute><AddStaff /></ProtectedRoute>} />
         <Route path="/staff/*" element={<ProtectedRoute><Staff /></ProtectedRoute>} />
         <Route path="/new-absence/*" element={<ProtectedRoute><AddAbsence /></ProtectedRoute>} />
         <Route path="/create-entry/*" element={<ProtectedRoute><CreateEntry /></ProtectedRoute>} />
         <Route path="/entries-by-class/*" element={<ProtectedRoute><HealthEntries /></ProtectedRoute>} />
         <Route path="/health-analytics/*" element={<ProtectedRoute><HealthAnalytics /></ProtectedRoute>} />
         <Route path="/staff-entries/*" element={<ProtectedRoute><StaffEntries /></ProtectedRoute>} />
         <Route path="/student-entries/*" element={<ProtectedRoute><StudentEntries /></ProtectedRoute>} />
         <Route path="/create-new-withdrawal/*" element={<ProtectedRoute><CreateNewWithdrawal /></ProtectedRoute>} />
         <Route path="/create-new-student/*" element={<ProtectedRoute><CreateNewStudent /></ProtectedRoute>} />
         <Route path="/student-withdrawals/*" element={<ProtectedRoute><StudentWithdrawals /></ProtectedRoute>} />
         <Route path="/new-students/*" element={<ProtectedRoute><NewStudents /></ProtectedRoute>} />
         <Route path="/withdrawal-analytics/*" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
         <Route path="*" element={<PageNotFound />} />
       </Routes>
     </div>
   </AuthContextProvider>
 );
}


export default App;
